/* Router */

import Landing from './views/landing.vue';
import Home from './views/home.vue';
import Default from './views/default.vue';
import About from './views/about.vue';
import Program from './views/program.vue';
import Artists from './views/artists.vue';
import Profile from './views/profile.vue';
import Year from './views/year.vue';
import Event from './views/event.vue';
import Popup from './views/popup.vue';


export default [
  {
    path: '/',
    component: Landing,
    children: [
      {
        path: '',
        components: {
          main: Year
        }
      },
      {
        path: ':year',
        components: {
          main: Year
        }
      },
      {
        path: ':year/about',
        components: {
          main: About
        }
      },
      {
        path: ':year/program',
        components: {
          main: Program
        }
      },
      {
        path: ':year/program/:event',
        components: {
          main: Program,
          overlay: Event
        }
      },
      {
        path: ':year/artists',
        components: {
          main: Artists
        }
      },
      {
        path: ':year/artists/:profile',
        components: {
          main: Artists,
          overlay: Profile
        }
      },
      {
        name: 'popup',
        path: ':year/:default/:popup',
        components: {

          main: Default,
          overlay: Popup
        },
      },
      {
        path: ':year/:default',
        components: {
          main: Default
        },
        children: [
          {
            name: 'oldpopup',
            path: ':popup',
            components: {
              popup: Popup
            }
          }
        ]
      },
    ]
  },
]
